Vue.asyncComponent('cms-dashboard-page-status-check', {
    props: {
        statusLabel: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        isEnabled: {
            type: Boolean,
            default: false,
        },
        href: {
            type: String,
            default: '',
        },
        target: {
            type: String,
            default: '_self',
        },
    },
    computed: {
        /**
         * Resolve the button label/title for the page link.
         *
         * @return {string}
         */
        pageLinkTitle() {
            if (this.isEnabled) {
                return this.$t('Pagina instellen');
            }

            return this.$t('Ga naar pagina');
        },
    },
}, 'cms/dashboard/live/cms-dashboard-page-status-check.html');
